import { useBrand } from "@fprint/ui";
import { Link } from "react-router-dom";

export function NotFound() {
  const brand = useBrand();
  return (
    <main className="mx-auto flex min-h-screen max-w-xl flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-3xl font-semibold">404</h1>
      <p className="text-muted-fg">That page does not exist.</p>
      <Link to="/" className="text-primary underline">
        Back to {brand.name}
      </Link>
    </main>
  );
}
